/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：682__part-1
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_6 from /* 6 */"./6"
import * as /* [auto-meaningful-name] */Src_editor_widget_builtIn_types from /* 5 */"../../../../src/editor/widget/built-in/types"
import * as /* [auto-meaningful-name] */Module_33 from /* 33 */"./33"
import * as /* [auto-meaningful-name] */Module_244 from /* 244 */"./244"
var c = {
  type: Src_editor_widget_builtIn_types.f,
  icon: "icon-widget-canvas",
  title: "widgetName",
  platforms: ["web", "android", "ios"],
  isGlobalWidget: false,
  isInvisibleWidget: false,
  properties: [
    {
      key: "backgroundColor",
      label: "backgroundColor",
      valueType: "color",
      defaultValue: Module_244.a
    }, Module_6.a({}, Module_33.i)
  ],
  methods: [],
  events: []
}
export { c }
